/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { KissReaderStateDto, KissService } from "app/services/kiss.service";

@Injectable()
export class KissReaderStateResolver implements Resolve<KissReaderStateDto> {

  constructor(
    private kissService: KissService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<KissReaderStateDto> {
    // Get the 'ID' Path parameter which is the ID of the Service to obtain...
    const id = route.paramMap.get('id');
    console.log(`Obtaining Reader for Portal ID: '${id}'...`);
    
    if (id == null || id.length == 0) {
      return null;
    }

    return await this.kissService.getReaderState(id).toPromise();
  }

}
